import { Col, Row, Radio, DatePicker, Button } from "antd";
import React, { useEffect, useState } from "react";
import Charts from "./chart";
import ResultChart from "./resultChart";
import WorkChart from "./workChart";
import InspectionApi from "../../../api/inspectionnew";
import { alarmApi } from "../../../api/newApi";
import moment from "moment";
import "./style.scss";
const { RangePicker } = DatePicker;

export default () => {
  const userInfo = sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo"))
    : {};

  let stationId = -1;
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0] * 1)
      : (stationId = userInfo.stationIds * 1);
  }
  const [value, setValue] = useState("month");
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState([moment().subtract(1, "months"), moment()]);
  const [defectInfo, setDefectInfo] = useState({});
  const [workInfo, setWorkInfo] = useState({});
  const [chartData, setChartData] = useState({});
  const [resultChartData, setResultChartData] = useState({});
  const [workChartData, setWorkChartData] = useState({});
  const [alarmInfo, setAlarmInfo] = useState({
    completedAlarmNum: 0,
    unreadAndProcessingAlarmNum: 0,
    unreadAlarmNum: 0,
    processingAlarmNum: 0,
  });
  const boxStyle = {
    height: 360,
    border: "1px solid #ddd",
    display: "flex",
    justifyContent: "space-between",
    padding: 20,
  };

  useEffect(() => {
    getDefectOrderStatistics();
    getPatrolWorkOrderStatistics();
    getSelectAllAlarmNum();
  }, [time]);

  const getSelectAllAlarmNum = () => {
    alarmApi.selectAllAlarmNum([stationId]).then((res) => {
      if (res.status !== "0") return;
      const { unreadAlarmNum, processingAlarmNum, completedAlarmNum } =
        res.data;
      setAlarmInfo(res.data);
      setChartData({
        color: ["#FF0000", "#0099CC", "#00CC00"], // 全局颜色列表
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
        },
        series: [
          {
            name: "报警事件统计",
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: [
              { value: unreadAlarmNum || 0, name: "未处理" },
              { value: processingAlarmNum || 0, name: "处理中" },
              { value: completedAlarmNum || 0, name: "已完成" },
            ],
          },
        ],
      });
    });
  };

  const getDefectOrderStatistics = () => {
    const params = {
      stationId,
      startTime: time[0].format("YYYY-MM-DD") + " 00:00:00",
      endTime: time[1].format("YYYY-MM-DD") + " 23:59:59",
    };
    InspectionApi.getDefectOrderStatistics(params).then((res) => {
      if (res.status !== "0") return;
      const { unhandleNumber, handlingNumber, timeoutNumber, finishNumber } =
        res.data;
      setDefectInfo(res.data);
      setResultChartData({
        color: ["#FF0000", "#0099CC", "#FF682D", "#00CC00"], // 全局颜色列表
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
        },
        series: [
          {
            name: "缺陷单统计",
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: [
              { value: unhandleNumber || 0, name: "未完成" },
              { value: handlingNumber || 0, name: "处理中" },
              { value: timeoutNumber || 0, name: "超时" },
              { value: finishNumber || 0, name: "完成" },
            ],
          },
        ],
      });
    });
  };

  const getPatrolWorkOrderStatistics = () => {
    const params = {
      stationId,
      startTime: time[0].format("YYYY-MM-DD") + " 00:00:00",
      endTime: time[1].format("YYYY-MM-DD") + " 23:59:59",
    };
    InspectionApi.getPatrolWorkOrderStatistics(params).then((res) => {
      if (res.status !== "0") return;
      setWorkInfo(res.data);
      const { unhandleNumber, handlingNumber, timeoutNumber, finishNumber } =
        res.data;
      setWorkChartData({
        color: ["#FF0000", "#0099CC", "#FF682D", "#00CC00"], // 全局颜色列表
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
        },
        series: [
          {
            name: "工单统计",
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: [
              { value: unhandleNumber || 0, name: "未处理" },
              { value: handlingNumber || 0, name: "处理中" },
              { value: timeoutNumber || 0, name: "超时" },
              { value: finishNumber || 0, name: "已完成" },
            ],
          },
        ],
      });
    });
  };

  const changeRadio = (e) => {
    const value = e.target.value;
    setValue(value);
    if (value === "month") {
      setTime([moment().subtract(1, "months"), moment()]);
    } else if (value === "square") {
      setTime([moment().subtract(3, "months"), moment()]);
    } else if (value === "year") {
      setTime([moment().subtract(1, "years"), moment()]);
    }
  };

  const reset = () => {
    setTime([moment().subtract(1, "months"), moment()]);
    setValue("month");
  };

  const search = () => {
    getDefectOrderStatistics();
    getPatrolWorkOrderStatistics();
  };

  return (
    <div className="alarm-handler" style={{ padding: 10 }}>
      <Row gutter={20}>
        <Col span={4}>
          <Radio.Group
            style={{ width: "100%" }}
            value={value}
            onChange={changeRadio}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className="button-children" value="month">
              月
            </Radio.Button>
            <Radio.Button className="button-children" value="square">
              季度
            </Radio.Button>
            <Radio.Button className="button-children" value="year">
              年
            </Radio.Button>
          </Radio.Group>
        </Col>
        <Col span={6}>
          开始日期：
          <RangePicker value={time} onChange={(e) => setTime(e)} />
        </Col>
        <Col span={4}>
          <Button onClick={reset}>重置</Button>
          <Button
            onClick={search}
            type="primary"
            loading={loading}
            style={{ marginLeft: 8 }}
          >
            查询
          </Button>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }} gutter={20}>
        <Col span={12}>
          <div style={boxStyle}>
            <div className="chart-desc" style={{ width: "40%" }}>
              <h3>报警事件统计</h3>
              <div style={{ margin: "20px 0" }}>
                <p>报警总数</p>
                <p className="total">
                  {alarmInfo.completedAlarmNum +
                    alarmInfo.unreadAndProcessingAlarmNum}
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p>未处理</p>
                  <p className="error">{alarmInfo.unreadAlarmNum}</p>
                </div>
                <div style={{ margin: "0 20px" }}>
                  <p>处理中</p>
                  <p className="primary">{alarmInfo.processingAlarmNum}</p>
                </div>
                <div>
                  <p>已完成</p>
                  <p className="success">{alarmInfo.completedAlarmNum}</p>
                </div>
              </div>
            </div>
            <div style={{ width: "60%", height: "100%" }}>
              <Charts id="taskCharts" height="100%" chartData={chartData} />
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div style={boxStyle}>
            <div className="chart-desc" style={{ width: "40%" }}>
              <h3>缺陷单统计</h3>
              <div style={{ margin: "20px 0" }}>
                <p>缺陷单总数</p>
                <p className="total">{defectInfo.totalNumber || 0}</p>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p>未处理</p>
                  <p className="error">{defectInfo.unhandleNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>处理中</p>
                  <p className="primary">{defectInfo.handlingNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>超时</p>
                  <p className="warning">{defectInfo.timeoutNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>已完成</p>
                  <p className="success">{defectInfo.finishNumber || 0}</p>
                </div>
              </div>
            </div>
            <div style={{ width: "60%", height: "100%" }}>
              <ResultChart
                id="resultCharts"
                height="100%"
                chartData={resultChartData}
              />
            </div>
          </div>
        </Col>
        <Col span={12} style={{ marginTop: 20 }}>
          <div style={boxStyle}>
            <div className="chart-desc" style={{ width: "40%" }}>
              <h3>工单统计</h3>
              <div style={{ margin: "20px 0" }}>
                <p>工单总数</p>
                <p className="total">{workInfo.totalNumber || 0}</p>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p>未处理</p>
                  <p className="error">{workInfo.unhandleNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>处理中</p>
                  <p className="primary">{workInfo.handlingNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>超时</p>
                  <p className="warning">{workInfo.timeoutNumber || 0}</p>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <p>已完成</p>
                  <p className="success">{workInfo.finishNumber || 0}</p>
                </div>
              </div>
            </div>
            <div style={{ width: "60%", height: "100%" }}>
              <WorkChart
                id="workChart"
                height="100%"
                chartData={workChartData}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
